import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { AuthUserContext, withAuthorization } from '../Session';
import * as ROUTES from "../../constants/routes";
import {sortByName} from "../../utils";

class ProjectsCategoriesPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            projectsCategories: [],
            search: '',
        };
    }

    componentDidMount() {
        this.setState({ loading: true });

        this.props.firebase.projectsCategories().on('value', snapshot => {
            const projectsCategoriesObject = snapshot.val() ? snapshot.val() : [];

            const projectsCategoriesList = Object.keys(projectsCategoriesObject).map(key => ({
                ...projectsCategoriesObject[key],
                uid: key,
            }));

            projectsCategoriesList.sort(sortByName);

            this.setState({
                projectsCategories: projectsCategoriesList,
                loading: false,
            });
        });
    }

    componentWillUnmount() {
        this.props.firebase.projectsCategories().off();
    }

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    deleteProjectsCategory = (uid) => {
        this.props.firebase
            .projectsCategory(uid).remove()
            .then(() => {

            })
            .catch(error => {
                this.setState({ error });
            });
    };

    render() {
        const { projectsCategories, search, loading } = this.state;

        return (
            <AuthUserContext.Consumer>
                {() => (
                    <div className="container">
                        <div className="row mb-5">
                            <div className="col-12 col-md-6">
                                <div className="row no-gutters align-items-center justify-content-between">
                                    <h1>Projects Categories</h1>
                                </div>
                                <div className="row no-gutters align-items-center justify-content-between">
                                    <div className="form-group mb-3 mb-md-0">
                                        <input
                                            className="form-control"
                                            name="search"
                                            value={search}
                                            onChange={this.onChange}
                                            type="text"
                                            placeholder="Search projects category"
                                        />
                                    </div>
                                    <Link to={ROUTES.PROJECTS_CATEGORIES_ADD}><button className="btn btn-outline-primary">Add projects category</button></Link>
                                </div>
                            </div>
                        </div>

                        {loading && <div>Loading ...</div>}
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <ProjectsCategoriesList projectsCategories={projectsCategories.filter(projectsCategory => projectsCategory.name && projectsCategory.name.toLowerCase().includes(search.toLowerCase()))} deleteProjectsCategory={this.deleteProjectsCategory}/>
                            </div>
                        </div>
                    </div>
                )}
            </AuthUserContext.Consumer>
        );
    }
}

const ProjectsCategoriesList = ({ projectsCategories, deleteProjectsCategory }) => (
    <table className="table">
        <thead className="thead-dark" >
        <tr>
            <th>Project category name</th>
            <th>Action</th>
        </tr>
        </thead>
        <tbody>
        {
            projectsCategories.length > 0 ?
                (projectsCategories.map(projectsCategory => (
                        <tr key={projectsCategory.uid}>
                            <td><Link to={'/admin/projects-categories/' + projectsCategory.uid}>{projectsCategory.name}</Link></td>
                            <td><button className="btn btn-danger" onClick={() => deleteProjectsCategory(projectsCategory.uid)}>Delete</button></td>
                        </tr>
                    ))
                ) :
                (
                    <tr>
                        <td className="text-center py-4" colSpan="2">Projects categories list is empty</td>
                    </tr>
                )
        }
        </tbody>
    </table>
);

const condition = authUser => !!authUser;

export default withAuthorization(condition)(ProjectsCategoriesPage);